import { render, staticRenderFns } from "./mealStastics.vue?vue&type=template&id=4a81728f&scoped=true"
import script from "./mealStastics.vue?vue&type=script&lang=js"
export * from "./mealStastics.vue?vue&type=script&lang=js"
import style0 from "./mealStastics.vue?vue&type=style&index=0&id=4a81728f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a81728f",
  null
  
)

export default component.exports